import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider, useStore } from 'react-redux';

import { Toast } from '@/components/molecules/Toast';
import { ColorSchemeProvider } from '@/context/ColorSchemeProvider';
import { noop } from '@/utility/noop';

type ToastType = 'success' | 'error';

export interface ToastManager {
  show(message: string, type?: ToastType): void;
  remove(): void;
}

export const useToast = (): ToastManager => {
  const store = useStore();
  const ref = React.useRef<VoidFunction>(noop);

  return {
    show: (message: string, type: ToastType = 'success'): void => {
      const body = document.body;
      const container = document.createElement('div');
      const root = ReactDOM.createRoot(container);

      container.setAttribute('class', 'dashboard-toast');
      container.setAttribute('role', 'alert');

      body.append(container);
      root.render(
        <Provider store={store}>
          <ColorSchemeProvider>
            <Toast text={message} type={type} />
          </ColorSchemeProvider>
        </Provider>,
      );

      ref.current = (): void => {
        try {
          container.remove();
        } catch {
          // Nothing
        }
      };

      setTimeout(ref.current, 5000);
    },
    remove: (): void => {
      ref.current();
    },
  };
};
